import InviteIndex from '@/invite/views/Index.vue';
import Create from '@/invite/views/Create.vue';

const routes = [
  {
    path: '/invite/',
    name: 'Invite-Index',
    component: InviteIndex,
  },

  {
    path: '/invite/create',
    name: 'Invite-Create',
    component: Create,
  },
];

export default routes;
